import { get, ref, serverTimestamp, update } from 'firebase/database'
import { db } from '../firebase'

export function normalizeDeviceId(deviceId) {
  return String(deviceId || '').trim()
}

/**
 * Mesma lógica do app (Sysmv-c): ID deve existir em devices/{id}/config e estar sem dono.
 * reason: empty | not_found | already_owned | network | ok
 */
export async function checkDeviceAvailability(deviceId) {
  const cleanId = normalizeDeviceId(deviceId)
  if (!cleanId) {
    return {
      available: false,
      reason: 'empty',
      message: 'Informe o ID do dispositivo.',
    }
  }

  try {
    const configRef = ref(db, `devices/${cleanId}/config`)
    const snapshot = await get(configRef)

    if (!snapshot.exists()) {
      return {
        available: false,
        reason: 'not_found',
        message: 'ID não encontrado. Confira a etiqueta ou o QR do aparelho.',
        deviceId: cleanId,
      }
    }

    const config = snapshot.val() || {}
    if (config.ownerUid && String(config.ownerUid).trim() !== '') {
      return {
        available: false,
        reason: 'already_owned',
        message: 'Este dispositivo já está vinculado a outra conta.',
        deviceId: cleanId,
      }
    }

    return {
      available: true,
      reason: 'ok',
      message: 'ID disponível para cadastro.',
      deviceId: cleanId,
    }
  } catch (error) {
    const msg = String(error?.message || '')
    if (msg.includes('permission_denied') || msg.includes('Permission denied')) {
      return {
        available: false,
        reason: 'already_owned',
        message: 'Este dispositivo já está vinculado a outra conta.',
        deviceId: cleanId,
      }
    }
    console.error('Erro ao verificar dispositivo:', error)
    return {
      available: false,
      reason: 'network',
      message: 'Não foi possível verificar o ID. Confira sua conexão.',
      deviceId: cleanId,
    }
  }
}

export async function claimDeviceForUser(user, deviceId, { displayName } = {}) {
  const cleanId = normalizeDeviceId(deviceId)
  if (!user?.uid || !cleanId) {
    throw new Error('Não foi possível vincular o dispositivo.')
  }

  const availability = await checkDeviceAvailability(cleanId)
  if (!availability.available) {
    throw new Error(availability.message || 'Verifique se o ID informado está correto.')
  }

  const name = displayName || user.displayName || 'Usuário'
  const associationTimestamp = serverTimestamp()
  const updates = {
    [`devices/${cleanId}/config/ownerUid`]: user.uid,
    [`devices/${cleanId}/config/status`]: true,
    [`devices/${cleanId}/config/historyRetentionDays`]: 30,
    [`devices/${cleanId}/usuariosAssociados/${user.uid}`]: {
      role: 'owner',
      email: user.email || '',
      name,
      associationDate: associationTimestamp,
      photoURL: user.photoURL || null,
    },
    [`users/${user.uid}/dispositivosAssociados/${cleanId}`]: {
      dataAssociacao: associationTimestamp,
      notificacoesAtivas: true,
    },
    // Libera checkout no site (mesmo sinal usado após compra/claim comercial)
    [`users/${user.uid}/deviceClaimed`]: true,
    [`users/${user.uid}/deviceOwned`]: true,
    [`users/${user.uid}/deviceClaimedAt`]: Date.now(),
  }

  await update(ref(db), updates)
  return cleanId
}
